import styled from '@emotion/styled';
import React from 'react';

import { CCLoadingPlaceholder } from '../../components/ui/CCLoadingPlaceholder';
import { CepCustomFieldTypeIcon } from './CepCustomFieldTypeIcon';

const FDContainer = styled.div`
  display: flex;
`;

const FDType = styled.div`
  margin-right: 10px;
`;
const ContextName = styled.div`
  margin-left: 10px;
`;

const FDDescription = styled.div``;
export const CepHeaderFieldDetails = ({
  isLoading,
  fieldName,
  fieldType,
  fieldDescription,
  contextName,
  contextDescription,
}: {
  isLoading: boolean;
  fieldName: string;
  fieldType: string;
  fieldDescription: string;
  contextName: string | null;
  contextDescription: string | null;
}) => {
  return (
    <div>
      {isLoading ? (
        <CCLoadingPlaceholder width={500} height={20} />
      ) : (
        <FDContainer>
          <FDType>
            <CepCustomFieldTypeIcon type={fieldType} size="forHeader" />
          </FDType>
          <FDDescription>{fieldDescription}</FDDescription>

          {contextName && <ContextName>→ {contextName}</ContextName>}
        </FDContainer>
      )}
    </div>
  );
};
